import pannable from '../pannable/index'
import IdManager from '../IdManager/index'

import utils from '../utils/index'

import transformShape2path from '../utils/transformShape2path'

import constants from '../constants/index'

import strictClick from '../strictClick/index'

import formattableTitle from '../formattableTitle/index';


const FontSize = 13

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)

      this["ShapeLayerMixin@handleMouseMove"] = this["ShapeLayerMixin@handleMouseMove"].bind(this)
      this["ShapeLayerMixin@handleMouseDown"] = this["ShapeLayerMixin@handleMouseDown"].bind(this)
      this["ShapeLayerMixin@handleMouseOver"] = this["ShapeLayerMixin@handleMouseOver"].bind(this)
    }

    install() {
      super.install()

      let onPan = (dx, dy, x, y, e, panningTarget, panOffset) => {
        if (!(this.mode & constants.modeFilter.ShapePan)) {
          return
        }
        if (this.panningGroup) {
          // update panningGroup

          let box = this.svg.getBoundingClientRect()
          this.panningGroup.panEndPoint = this.snap(utils.unapplyMatrix(this.matrix, {
            x: x - box.left + panOffset.x,
            y: y - box.top + panOffset.y
          }))

          this.panningGroup = this.panningGroup

          this.requestAutoScroll(x, y)
        }
      }, onPanStart = (x, y, e, panningTarget, panOffset) => {
        if (!(this.mode & constants.modeFilter.ShapePan)) {
          return
        }
        if (utils.hasClass(panningTarget, "shape")) {
          let shape = panningTarget
            , [_, shapeId] = IdManager.split(shape.id)
            , mousePoint = this.getShapePosition(shapeId)
          this.beforeSnap(shapeId)

          // create a panningGroup
          if (utils.isEmpty(this.selectsObjectIds)) {
            this.panningGroup = {
              shapes: { [shapeId]: true },
              lines: {},
              panStartPoint: mousePoint,
              panEndPoint: mousePoint
            }
          } else {
            this.panningGroup = {
              shapes: utils.assign({}, this.selectsObjectIds),
              lines: Object.keys(this.lines).reduce((p, c, i, a) => {
                if ((this.lines[c].sourceShapeId in this.selectsObjectIds) && (this.lines[c].targetShapeId in this.selectsObjectIds)) {
                  p[c] = true
                }
                return p
              }, {}),
              panStartPoint: mousePoint,
              panEndPoint: mousePoint
            }
          }

        }
      }, onPanEnd = e => {
        // apply the panningGroup to the real object
        if (this.panningGroup) {
          let { panEndPoint, panStartPoint } = this.panningGroup
            , dp = ({
              x: panEndPoint.x - panStartPoint.x,
              y: panEndPoint.y - panStartPoint.y
            })
          Object.keys(this.panningGroup.shapes).forEach(shapeId => {
            let m = this.shapes[shapeId].matrix
            m[4] += dp.x
            m[5] += dp.y
          })

          Object.keys(this.panningGroup.lines).forEach(lineId => {
            let points = this.lines[lineId].points
            points.forEach(p => {
              p.x += dp.x
              p.y += dp.y
            })
          })

          for (let lineId in this.lines) {
            if (this.lines.hasOwnProperty(lineId)) {
              if ((this.lines[lineId].sourceShapeId in this.panningGroup.shapes) ||
                (this.lines[lineId].targetShapeId in this.panningGroup.shapes)) {
                // @ts-ignore
                this.lines[lineId].points = this.getPoints(this.lines[lineId])
              }
            }
          }

          this.shapes = this.shapes
          this.lines = this.lines
        }
        this.afterSnap()
        this.panningGroup = null
        this.cancelAutoScroll()
      }

      this["ShapeLayerMixin@pannableHandler"] = pannable(this.svg, onPan, onPanStart, onPanEnd)

      this.svg.addEventListener("mousemove", this["ShapeLayerMixin@handleMouseMove"], false)
      this.svg.addEventListener("mousedown", this["ShapeLayerMixin@handleMouseDown"], false)
      this.svg.addEventListener("mouseover", this["ShapeLayerMixin@handleMouseOver"], false)
      this["ShapeLayerMixin@handleClick"] = strictClick(this.svg, e => {
        if (utils.closest(e.target, '[data-action="remove-focus-object"]')) {

          if (this.focusObjectId in this.shapes) {
            this.removeShape(this.shapes[this.focusObjectId])
          }
        }

        if (constants.modeFilter.ShapeFocus & this.mode) {
          let shape = utils.closest(e.target, ".shape")
          if (shape) {
            let [_, shapeId] = IdManager.split(shape.id)
            // focus shape
            this.focusShape(this.shapes[shapeId])
          }
        }
      })

      this.formattableTitle = new formattableTitle();
    }

    destroy() {
      super.destroy()
      this["ShapeLayerMixin@pannableHandler"]()

      this.svg.removeEventListener("mousemove", this["ShapeLayerMixin@handleMouseMove"], false)
      this.svg.removeEventListener("mousedown", this["ShapeLayerMixin@handleMouseDown"], false)
      this.svg.removeEventListener("mouseover", this["ShapeLayerMixin@handleMouseOver"], false)
      this["ShapeLayerMixin@handleClick"]()
      this.formattableTitle.destroy();
    }


    ["ShapeLayerMixin@handleMouseMove"](e) {
      if (this.ghostShape) {
        // 更新ghostShape 位置
        let m = this.ghostShape.matrix.slice(0)
          , frameBx = this.svg.getBoundingClientRect()
          , { x, y } = this.snap(utils.unapplyMatrix(this.matrix, {
            x: e.clientX - frameBx.left,
            y: e.clientY - frameBx.top
          }));

        m[4] = x
        m[5] = y
        this.ghostShape = utils.assign({}, this.ghostShape, {
          matrix: m
        })

        // this.requestAutoExtent(e.clientX, e.clientY)
      }
    }

    ["ShapeLayerMixin@handleMouseDown"](e) {
      if (this.ghostShape) {
        this.createShape(this.ghostShape)
        this.ghostShape = null
        this.afterSnap()
        // this.cancelAutoExtent()
      }
    }

    "ShapeLayerMixin@handleMouseOver"(e) {
      const shape = utils.closest(e.target, ".shape")
      if (shape) {
        const [_, shapeId] = IdManager.split(shape.id)
        // focus shape
        let title = '';
        this.emit('requestTitle', this.shapes[shapeId], t => title = t);
        if (title) {
          this.formattableTitle.request(shape, title);
        }
      }
    }

    proxyBBoxWidth(bbox) {
      if(!bbox)return;
      let width=bbox.width;
      delete bbox.width;
      Object.defineProperty(bbox,"width",{
        get:function (){
          return width;
        },
        set:function (value){
          width=value;
        }
      })
    }
    addShape(type, typeName, html, meta) {
      let path = transformShape2path(html)
        // @ts-ignore
        , bbox = Snap.path.getBBox(path);
      if (type === 'normal') {
        //this.proxyBBoxWidth(bbox);
      }
      this.shapeDefs = utils.assign({}, this.shapeDefs, {
        [type]: {
          type,
          html,
          path,
          bbox,
          name: typeName || "",
          meta: utils.assign({}, {
            lineButtonTypes: []
          }, meta || {})
        }
      });
    }

    createShape(shape, silent) {
      let id = shape.id || IdManager.next()
      shape.id = id
      if (silent ? true : this.emit("createShape", shape)) {
        this.shapes = utils.assign({}, this.shapes, {
          [shape.id]: shape
        })
        this.focusShape(shape)
        return true
      }
      return false
    }

    updateShape(shape, silent) {
      if (silent ? true : this.emit("updateShape", shape)) {
        this.shapes = utils.assign({}, this.shapes, {
          [shape.id]: utils.assign({}, this.shapes[shape.id], shape)
        })
        for (let lineId in this.lines) {
          if (this.lines.hasOwnProperty(lineId)) {
            if (this.lines[lineId].sourceShapeId === shape.id ||
              this.lines[lineId].targetShapeId === shape.id) {
              // @ts-ignore
              this.lines[lineId].points = this.getPoints(this.lines[lineId])
            }
          }
        }
        this.lines = this.lines
        return true
      }
      return false
    }

    removeShape(shape, silent) {
      if (silent ? true : this.emit("removeShape", shape)) {

        this.shapes = utils.omit(this.shapes, [shape.id])

        if (this.focusObjectId === shape.id) {
          this.focusObjectId = null
          if (Object.keys(this.shapes).length) {
            this.focusShape(this.shapes[Object.keys(this.shapes)[0]])
          } else {
            this.blur()
          }
        }

        for (let lineId in this.lines) {
          if (this.lines.hasOwnProperty(lineId)) {
            if (this.lines[lineId].sourceShapeId === shape.id ||
              this.lines[lineId].targetShapeId === shape.id) {
              this.removeLine(this.lines[lineId], silent)
            }
          }
        }

        this.lines = this.lines
        return true
      }
      return false
    }

    focusShape(shape, silent) {
      if (silent ? true : this.emit("focusShape", shape)) {
        this.focusObjectId = shape.id
      }
      this.selectsObjectIds = {}
    }

    beforeCreateShape(desciption) {
      let des = utils.assign({}, desciption)

      des.id = des.id || IdManager.next()

      this.ghostShape = des

      this.beforeSnap()
    }

    getShapeDefByType(type) {
      return this.shapeDefs[type] || this.shapeDefs[Object.keys(this.shapeDefs)[0]]
    }

    setColor(idncolors) {
      this.colorOfShapes = idncolors.reduce((p, c, i, a) => {
        p[c.id] = c
        return p
      }, {})
    }

    renderOneShape(pid, def, shape, focusObjectId, isGhost) {

      if (utils.isRectNode(def)) {
        def.bbox.width = utils.getTextLen(shape.name);
        def.html=def.html.replace(/width="\d+"/,'width="'+def.bbox.width+'"');
      }
      let { id, type, name, matrix } = shape
        , { path, html, bbox, name: typeName } = def
        , htmlId = IdManager.join(pid, id)
        , clazz = "shape pannable"
        // , chunckNames = utils.chunkString(name, bbox.width / FontSize)
        , chunckNames=[shape.name]
        , lineHeight = FontSize * 1.5
        , typeNameVisible = this.typeNameVisible
        , firstLineY = (bbox.y + bbox.height / 2 - (chunckNames.length - 1) / 2 * lineHeight) + (typeName && typeNameVisible ? -lineHeight / 4 : 0)
        , lineX = bbox.x + bbox.width / 2
        // , tspans = utils.chunkString(name, bbox.width / FontSize).map((span, i, l) => {
        , tspans = [shape.name].map((span, i, l) => {
          let currentLineY = firstLineY + i * lineHeight

          return `<tspan 
          x="${lineX}" 
          y="${currentLineY}"
          dy="${FontSize * .8 / 2}"
          >${span}</tspan>`
        }).join("")
        , outlinePadding = 5
        , selected = id in this.selectsObjectIds
        , outline = `
          <rect 
            x="${bbox.x - outlinePadding}" 
            y="${bbox.x - outlinePadding}" 
            width="${bbox.width + outlinePadding + outlinePadding}" 
            height="${bbox.height + outlinePadding + outlinePadding}"
            visibility="${focusObjectId === id || selected ? "visible" : "hidden"}" 
            pointer-events = "none"
            fill="none" 
            stroke=${selected ? "rgb(255,116,0)" : "#8888FF"} 
            stroke-dasharray="3,3"
            shape-rendering = "crispEdges"
          ></rect>`
        // https://stackoverflow.com/questions/12260370/draw-text-in-svg-but-remove-background
        , filter = '' //`url(#${IdManager.join(this.id, "screenBlendMode")})`
        , color = this.colorOfShapes[id] || {}
        , fontColor = "#000"
        , opacity = 0

      if (color.color) {
        html = `
          <g fill=${color.color}>${this.removeInnerAttributeOfHtml(html, ["fill"])}</g>
        `
      }

      if (this.panningGroup && id in this.panningGroup.shapes) {
        opacity = .5
      }

      if (color.fontColor) {
        fontColor = color.fontColor
      }

      return `
        <g
          id = "${htmlId}"
          class = "${clazz}"
          transform = "matrix(${matrix.join(",")}) translate(-${bbox.x + bbox.width / 2}, -${bbox.y + bbox.height / 2})"
          ${isGhost ? `pointer-events="none"` : `pointer-events="all"`}
          ${opacity ? `style=opacity:${opacity}` : ``}
        >
          ${html}
    
          <g
            fill="${fontColor}"
          >
            <text 
              x="${bbox.x + bbox.width / 2}" 
              y="${bbox.y + bbox.height / 2}" 
              text-anchor="middle" 
              font-size="${FontSize}"
              stroke= "none"
              pointer-events="none"
              filter="${filter}"
            >
              ${tspans}
            </text>

            <text
              x="${bbox.x + bbox.width - 5}" 
              y="${bbox.y + bbox.height - lineHeight / 2 + 4}" 
              text-anchor="end" 
              font-size="${FontSize - 2}"
              stroke= "none"
              fill-opacity=".8"
              pointer-events="none"
              filter="${filter}"
              visibility="${typeName && typeNameVisible ? "visible" : "hidden"}"
            >${typeName}</text>
          </g>

          ${outline}
        </g>
      `
    }

    removeInnerAttributeOfHtml(html, attrs) {
      let reg = new RegExp(`((${attrs.join("|")})\\s*=\\s*['|"]?)\\s*(.*?)\\s*['|"]?(?=[\\s|\\/|>])`, 'g')
      return html.replace(reg, "")
    }

    renderOnePanningShape(def, shape, startPoint, endPoint) {
      if (def.type === 'normal') {
        def.bbox.width = utils.getTextLen(shape.name);
        def.html=def.html.replace(/width="\d+"/,'width="'+def.bbox.width+'"');
      }
      let { id, type, name, matrix } = shape
        , { path, html, bbox, name: typeName } = def
        , dx = endPoint.x - startPoint.x
        , dy = endPoint.y - startPoint.y
        , chunckNames = utils.chunkString(name, bbox.width / FontSize)
        , lineHeight = FontSize * 1.5
        , typeNameVisible = this.typeNameVisible
        , firstLineY = (bbox.y + bbox.height / 2 - (chunckNames.length - 1) / 2 * lineHeight) + (typeName && typeNameVisible ? -lineHeight / 4 : 0)
        , lineX = bbox.x + bbox.width / 2
        , tspans = utils.chunkString(name, bbox.width / FontSize).map((span, i, l) => {
          let currentLineY = firstLineY + i * lineHeight

          return `<tspan 
          x="${lineX}" 
          y="${currentLineY}"
          dy="${FontSize * .8 / 2}"
          >${span}</tspan>`
        }).join("")
      html = this.removeInnerAttributeOfHtml(html, ["filter", "stroke", "fill-opacity", "stroke-width", "stroke-opacity"])
      return `
        <g
          transform = "matrix(${matrix.join(",")}) translate(-${bbox.x + bbox.width / 2}, -${bbox.y + bbox.height / 2}) translate(${dx}, ${dy})"
          pointer-events="none"

          fill-opacity=".8"
          stroke="rgb(255, 195, 66)"
          stroke-width=2
        >
          ${html}

          <g
        >
          <text 
            x="${bbox.x + bbox.width / 2}" 
            y="${bbox.y + bbox.height / 2}" 
            text-anchor="middle" 
            font-size="${FontSize}"
            pointer-events="none"
            stroke=none
          >
            ${tspans}
          </text>

          <text
            x="${bbox.x + bbox.width - 5}" 
            y="${bbox.y + bbox.height - lineHeight / 2 + 4}" 
            text-anchor="end" 
            font-size="${FontSize - 2}"
            fill-opacity=".8"
            pointer-events="none"
            stroke=none
            visibility="${typeName && typeNameVisible ? "visible" : "hidden"}"
          >${typeName}</text>
        </g>
        </g>
      `
    }

    select(shapeIds) {
      this.selectsObjectIds = shapeIds.reduce((p, c, i, a) => {
        p[c] = true
        return p
      }, {})
    }

    selectAll() {
      this.select(Object.keys(this.shapes))
    }

    display() {
      let shapes = this.shapes
        , pid = this.id
        , defs = this.shapeDefs
        , ghostShape = this.ghostShape
        , focusObjectId = this.focusObjectId
      let shapesCode = Object.keys(shapes).map(shapeId => {
        let { id, type, name, matrix } = shapes[shapeId]
        return this.renderOneShape(pid, this.getShapeDefByType(type), shapes[shapeId], focusObjectId, false)
      }).join("")
        , ghostShapeCode = ghostShape
          ? this.renderOneShape(pid, this.getShapeDefByType(ghostShape.type), ghostShape, focusObjectId, true)
          : ``
        , panningGroupShapeCode = this.panningGroup && this.panningGroup.shapes
          ? Object.keys(this.panningGroup.shapes).map(shapeId => {
            let { id, type, name, matrix } = shapes[shapeId]
              , { panStartPoint, panEndPoint } = this.panningGroup
            return this.renderOnePanningShape(this.getShapeDefByType(type), shapes[shapeId], panStartPoint, panEndPoint)
          })
          : ``
      return super.display() + `<g>${shapesCode}${ghostShapeCode}</g><g>${panningGroupShapeCode}</g>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/ShapeLayerMixin.js